import forwardToURL from '../../../utils/forwardToURL';
import Track from '../../../utils/tracking';
import * as CheckoutAPIActions from '../../APIActions/CheckoutAPIActions';
import {setPageMessage} from '../../pageMessageActions';
import {stopOrderProcessing} from '../../site-actions';

const handleError = (isOnOrderProcessingPage, dispatch) => {
  if (!isOnOrderProcessingPage) {
    dispatch(stopOrderProcessing());
    dispatch(setPageMessage());
  } else {
    // Throwing error here to go into a catch block in the order processing page
    throw new Error('Error sending Razorpay action response to Checkout API');
  }
};

export default function sendRazorpayResponse(data, isOnOrderProcessingPage = false) {
  return dispatch => dispatch(CheckoutAPIActions.sendRazorpayResponseData(data))
    .then((response) => {
      if (response && (response.status === 200 || response.status === 202)) {
        if (!isOnOrderProcessingPage) {
          forwardToURL('/checkout/processing');
        }
      } else {
        Track.error(`Error sending Razorpay action response to Checkout API: response: ${JSON.stringify(response)}`);
        handleError(isOnOrderProcessingPage, dispatch);
      }
    })
    .catch((error) => {
      Track.error(`Error sending Razorpay action response on the ${isOnOrderProcessingPage ? 'Order Processing page' : 'Order Processing Overlay'}. ${error}`);
      handleError(isOnOrderProcessingPage, dispatch);
    });
}
